import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2 } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostEmotionalDrainPart2PT() {
  const articleData = {
    title: 'Por que algumas pessoas nos deixam esgotados? Parte 2',
    description: 'Mais padrões sutis que drenam sua energia. A IA detecta sobre-explicação, sabe-tudo, confusão de emojis e mais.',
    slug: 'emotional-drain-part-2',
    publishDate: '2025-11-16',
    author: 'Editorial Toxic Detector'
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    datePublished: articleData.publishDate,
    author: {
      '@type': 'Organization',
      name: 'ToxicDetector'
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector'
    }
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('Link copiado para a área de transferência!');
    }
  };
  return <>
      <MetaTags title="Por que algumas pessoas nos deixam esgotados? Parte 2 | ToxicDetector" description="Mais padrões sutis que drenam sua energia. A IA detecta sobre-explicação, sabe-tudo, confusão de emojis e mais." keywords="esgotamento emocional, vampiros de energia, relacionamentos tóxicos, análise IA" canonical={`https://toxicdetector.com/pt/blog/${articleData.slug}`} ogType="article" ogImage="https://toxicdetector.com/images/logo.png" schema={[articleSchema]} data-id="element-8764" data-mp="13cz6ie8nnanm" />

      <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-8765" data-mp="1w37rseyhmb6f">
        <header className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50" data-id="element-8766" data-mp="3s75fu2que0kv">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-8767" data-mp="3n82mvgo4zkt9">
            <div className="flex items-center justify-between" data-id="element-8768" data-mp="3n9nh156jh1ql">
              <Link to="/" className="flex items-center gap-2 group" data-id="element-8769" data-mp="5rugdp5wc62d">
                <span className="text-2xl" data-id="element-8770" data-mp="10ujgjws1nzv">🚩</span>
                <span className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-8771" data-mp="102pfditvybp">
                  ToxicDetector
                </span>
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-8772" data-mp="apm7igypvo5i">
                <Share2 size={20} className="text-gray-600" data-id="element-8773" data-mp="jrca8iy1u9il" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-16" data-id="element-8774" data-mp="2qh0cij94kzfz">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-12 hover:text-gray-900 transition-colors group" data-id="element-8775" data-mp="2lip1w6b0akwp">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-8776" data-mp="111g5hffw35sk" />
            Voltar ao Início
          </Link>

          <header className="mb-16" data-id="element-8777" data-mp="rabs2k5v3szu">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight leading-[1.1] text-gray-900" data-id="element-8778" data-mp="r90l6bh4e54i">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-500 text-sm gap-3" data-id="element-8779" data-mp="i9di7l8qsr9c">
              <time dateTime={articleData.publishDate} data-id="element-8780" data-mp="n9jg3j5lv9zv">
                {new Date(articleData.publishDate).toLocaleDateString('pt-BR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-8781" data-mp="22q9xme1tzwwb">•</span>
              <span data-id="element-8782" data-mp="22qtcflw6q564">{articleData.author}</span>
            </div>
          </header>

          <div className="prose prose-lg max-w-none" data-id="element-8783" data-mp="27ntms902hu31">
            <p className="text-2xl mb-10 leading-relaxed text-gray-700 font-medium" data-id="element-8784" data-mp="7mlmalei25zp">
              Bem-vindo de volta à Parte 2 da nossa série sobre esgotamento
              emocional. Na Parte 1, cobrimos os vampiros de energia óbvios.
              Agora mergulhamos mais fundo nos padrões mais sutis.
            </p>

            <section className="mb-16" data-id="element-8785" data-mp="3pt9oa2e96d15">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8786" data-mp="3ps8a3p1xxaf7">
                1️⃣ O Sobre-Explicador
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8787" data-mp="3g25av748708f">
                Alguém que responde a perguntas simples com romances e prende
                sua energia com detalhes desnecessários.
              </p>
            </section>

            <section className="mb-16" data-id="element-8788" data-mp="373jxrrhiwdf1">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8789" data-mp="322w40y1wtih4">
                2️⃣ O Sabe-Tudo
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8790" data-mp="2x4ublmilg6sz">
                Não importa o que você diga, essa pessoa sabe melhor ou já
                passou por pior. Um comportamento clássico de "One-Upper".
              </p>
            </section>

            <section className="mb-16" data-id="element-8791" data-mp="2wy24imzk1xqc">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8792" data-mp="2wz3ip0bvb0ca">
                3️⃣ Confusão de Emojis
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8793" data-mp="31v290tgrasfc">
                Usar emojis passivo-agressivos como 🙂 ou 🙃 em contextos sérios
                para criar confusão.
              </p>
            </section>
          </div>

          <div className="bg-red-600 rounded-2xl p-12 md:p-16 text-center text-white shadow-xl mt-16" data-id="element-8794" data-mp="2e70zpibr77yv">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-8795" data-mp="2iyivzt2u0kdi">
              Proteja sua energia.
            </h2>
            <p className="text-red-100 mb-10 text-xl leading-relaxed max-w-2xl mx-auto" data-id="element-8796" data-mp="1lgsne73wfhs7">
              Não se deixe esgotar. Descubra quem é bom para você.
            </p>
            <Link to="/upload" className="inline-block bg-white text-red-600 px-12 py-5 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105" data-id="element-8797" data-mp="1ifz7lxw6wjce">
              Escanear agora →
            </Link>
          </div>

          <div className="mt-20" data-id="element-8798" data-mp="1n9bil57y4rmo">
            <RelatedBlogPosts posts={[{
            title: 'Por que algumas pessoas nos deixam esgotados?',
            description: 'Saiba como a IA do Toxic Detector detecta comunicação unilateral.',
            slug: 'emotional-drain-relationships-ai',
            emoji: '😮‍💨'
          }, {
            title: '7 Sinais de Gaslighting',
            description: 'Descubra 7 sinais de gaslighting que nossa IA detecta instantaneamente.',
            slug: '7-signs-of-gaslighting',
            emoji: '💀'
          }]} data-id="element-8799" data-mp="1nacvzgcfpq7k" />
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-16 mt-24" data-id="element-8800" data-mp="2sfjuvqxqmui2">
          <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-8801" data-mp="2scxdz0oyj2n6">
            <p className="text-gray-400 text-sm" data-id="element-8802" data-mp="2eh3d94yc7jl5">
              © {new Date().getFullYear()} ToxicDetector. Todos os direitos
              reservados.
            </p>
          </div>
        </footer>
      </div>
    </>;
}